import React from 'react';
import { usePoll } from '../../data/fetch/useFetch';
import { getConfiguration } from '../../data/utils';
import { parseLiveData } from '../../data/parseLiveData';
import Loader from '../../common/Loader';

export default function LiveEventsFetcher(props) {
    const conf = getConfiguration();
    const [isLoading, isError, data] = usePoll(conf.api.getMenuLiveSingleMatchPage, null, (data) =>
        parseLiveData(data, false)
    );
    
    if (isLoading || isError) {
        return (
            <Loader error={isError} />
        );
    }
    
    return (
        <>
            {props.renderItem(data)}
        </>
    );
}
